import { render, staticRenderFns } from "./WhiteLabelEmailColors.vue?vue&type=template&id=224be822"
import script from "./WhiteLabelEmailColors.vue?vue&type=script&lang=js"
export * from "./WhiteLabelEmailColors.vue?vue&type=script&lang=js"
import style0 from "./WhiteLabelEmailColors.vue?vue&type=style&index=0&id=224be822&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports